import * as React from 'react';
import { SquareButton } from '../../../components/actions/SquareButton';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { Void } from '../../../models/basic-objects';
import { SocialAuthTokenQuery } from '../../../models/graphql';
import classes from './FacebookSignupLabel.module.scss';

export type FacebookSignupLabelViewProps = {
  //
  onClose: Void;
  signupData: SocialAuthTokenQuery['socialAuthToken'];
  disabled?: boolean;
};

export const FacebookSignupLabelView = (props: FacebookSignupLabelViewProps): JSX.Element => {
  return (
    <div className={classes.FacebookSignupLabel}>
      <div className={'grid-x align-justify align-middle'}>
        <div className={'cell shrink'}>
          <div className={'grid-x align-middle'}>
            <div className={'cell shrink'}>
              <div className={classes.FacebookSignupImageWrapper}>
                <img
                  className={classes.ProfileImg}
                  src={props.signupData.photoUrl}
                  alt={props.signupData?.firstName ?? ''}
                />
              </div>
            </div>
            <div className={'cell shrink'}>
              <div className={classes.FacebookSignupName}>{props.signupData.firstName}</div>
            </div>
          </div>
        </div>
        <div className={'cell shrink'}>
          <SquareButton
            disabled={props.disabled}
            type={'transparent'}
            icon={SquareButtonIconsEnum.close}
            action={props.onClose}
          />
        </div>
      </div>
    </div>
  );
};
